import type { Maybe } from '@adornis/base/utilTypes.js';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '@adornis/chemistry/elements/components/x-flex.js';
import '@adornis/chemistry/elements/components/x-icon.js';
import { ExamType, OsceCategoriesByExamType, OSCECategory } from '@ils/static/enums.js';
import type { ILSThemeDefinition } from '@ils/theme/theme.js';
import { html, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { state } from 'lit/decorators/state.js';
import type { OSCE } from '../db/osce.js';

@customElement('ils-osce-type')
export class ILSOSCEType extends ChemistryLitElement<ILSThemeDefinition> {
  override styles() {
    return [
      {
        ':host': {
          fontSize: '1em',
          fontStyle: 'normal',
          display: 'inline-block',
          lineHeight: '1',
          verticalAlign: 'bottom',
        },
      },
    ];
  }
  @state() public osce?: OSCE;

  private get _secondIcon() {
    if (!this.osce?.enableVideo) return 'phone_enabled';
    return 'person';
  }

  private get _firstIcon() {
    if (this.osce?.taskType === 'text') return 'notes';
    if (!this.osce?.enableVideo) return 'phone_enabled';
    return 'person';
  }

  override render() {
    if (!this.osce?.osceType)
      return html` <x-icon ${css({ color: this.colors.role.doctor })}> question_mark </x-icon> `;
    const { first, second } = this.getColors(this.osce.osceType);
    return html`
      <x-flex horizontal>
        <x-icon ${css({ color: first })}> ${this._firstIcon} </x-icon>
        ${this.osce.taskType === 'voice'
          ? html` <x-icon ${css({ color: second, marginLeft: '-.6em' })}> ${this._secondIcon} </x-icon> `
          : nothing}
      </x-flex>
    `;
  }

  private getColors(type?: Maybe<OSCECategory>) {
    if (!type) return { first: this.colors.role.doctor, second: this.colors.role.doctor };
    let second = this.colors.role.doctor;
    switch (type) {
      case OSCECategory.FAMED_ANMANESEGESPRAECH:
        second = this.colors.role.patient;
        break;
      case OSCECategory.FAMED_AUFKLAERUNGSGESPERAECH:
        second = this.colors.role.patient;
        break;
      case OSCECategory.FAMED_PATIENTEN_UEBERGABE:
        second = this.colors.role.doctor;
        break;
      case OSCECategory.FAMED_PATIENTEN_VORSTELLUNG:
        second = this.colors.role.nurse;
        break;
      case OSCECategory.FSPP_ANMANESEGESPRAECH:
        second = this.colors.role.patient;
        break;
      case OSCECategory.FSPP_AUFKLAERUNGSGESPERAECH:
        second = this.colors.role.patient;
        break;
      case OSCECategory.FSPP_PATIENTEN_UEBERGABE:
        second = this.colors.role.doctor;
        break;
      case OSCECategory.FSPP_PATIENTEN_VORSTELLUNG:
        second = this.colors.role.nurse;
        break;
    }
    return {
      first: OsceCategoriesByExamType[ExamType.FAMED].includes(type) ? this.colors.role.doctor : this.colors.role.nurse,
      second,
    };
  }
}
